// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","682":"component---src-pages-about-js"}[chunkId] + "-" + {"351":"7c49523a01d2ec408729","532":"8d503d725f6c37f4c435","678":"55f43a8265d0084c181c","682":"34c8b0b69d784fa14582"}[chunkId] + ".js";
};